import { PAY_DEBT_TO_DRIVER, PAY_OFFLINE } from "../../routes";
import customAxios from "../../customAxios";
import { IPayDebtToDriver } from "../../../types/company.interface";

async function payDriverDebt(props: IPayDebtToDriver) {
  const thisUrl = PAY_DEBT_TO_DRIVER + "/" + props.debtId;

  let body: IPayDebtToDriver = {
    fishId: props.fishId,
    paidDate: props.paidDate,
    paymentType: props.paymentType,
  };

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ PAY_DEBT_TO_DRIVER: error });
  }
}

export default payDriverDebt;
